module.exports = __webpack_public_path__ + "img/faq_bg.bafc7795.webp";